import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CommentsBox from "../../../../CommonComponents/comments/CommentsBox";

const CaseDescriptionBox = ({
  data = [],
  index,
  styles = null,
  headerStyles = {},
  onClickComments = () => {},
  employee_name,
}) => {
  const validData = data?.filter((item) => item.role_label !== null);
  const totalComments = validData?.reduce(
    (total, item) => total + item?.description_details?.length,
    0
  );
  return (
    <Box
      sx={{
        boxShadow: styles ? styles?.boxShadow : "0px 4px 10px #FF599126",
        borderRadius: "12px",
        padding: "14px",
      }}
      key={index}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...headerStyles,
          mb: 2,
        }}
      >
        <Typography sx={{ fontWeight: 600, color: "#000000" }}>
          Comments
        </Typography>
        <Typography
          sx={{ fontWeight: 600, color: "#000000" }}
          onClick={onClickComments}
        >
          {totalComments} <span>Comments</span>
        </Typography>
      </Box>
      {/* body */}
      <CommentsBox
        sidebarTable={true}
        data={validData}
        employee_name={employee_name}
      />
    </Box>
  );
};

export default CaseDescriptionBox;
